
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    PricingServicesPopups: () => import("@/modules/Pricing/Services/PricingServicesPopups.vue"),
  },
})
export default class Employer extends Vue {}
